import {Strand} from 'constants/MolbioConstants';

/**
 * Determine the y placement and height of the overlay feature to draw based on the strand
 * of the feature and whether the base complements are being rendered.
 *
 * @param showingComplement Whether the complement layer of the nucleotide bases is being rendered
 * @param basesHeight Height of one layer of bases; the bases and revcomp together would be double this height
 * @param strand Strand of the feature
 */
export function getVerticalPlacement(
  showingComplement: boolean,
  basesHeight: number,
  strand: Strand
): {y: number; height: number} {
  if (!showingComplement || strand === 1) {
    return {y: 0, height: basesHeight};
  } else if (strand === 0) {
    return {y: 0, height: basesHeight * 2};
  } else {
    return {y: basesHeight, height: basesHeight};
  }
}
